import { COLORS, FONTS, TYPE, SPACING } from "../theme.js";

// Modern — sans-serif, gold accent on section headings, left-aligned strong header.
export const modernStyles = {
  meta: { label: "Modern (gold accent)" },

  page: {
    ...SPACING.pagePadding,
    backgroundColor: COLORS.white,
    fontFamily: FONTS.sans,
    fontSize: TYPE.body,
    color: COLORS.navy,
    lineHeight: 1.4,
  },

  header: {
    marginBottom: 10,
    paddingBottom: 8,
    borderBottomWidth: 2,
    borderBottomColor: COLORS.gold,
  },
  headerName: {
    fontSize: TYPE.name,
    fontFamily: FONTS.sansBold,
    color: COLORS.navy,
    letterSpacing: 0.2,
    marginBottom: 12,
  },
  headerHeadline: {
    fontSize: TYPE.headline,
    color: COLORS.goldDeep,
    fontFamily: FONTS.sansBold,
    marginTop: 2,
    letterSpacing: 0.2,
  },
  headerContact: {
    fontSize: TYPE.micro,
    color: COLORS.slate,
    marginTop: 5,
  },
  sep: { color: COLORS.mute },

  section: { marginTop: SPACING.sectionGap },
  sectionHeadingWrap: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 6,
  },
  sectionHeading: {
    fontSize: TYPE.sectionHeading,
    fontFamily: FONTS.sansBold,
    textTransform: "uppercase",
    letterSpacing: 2,
    color: COLORS.navy,
    paddingRight: 8,
  },
  // Trailing rule on the right of the section heading
  sectionRule: {
    flex: 1,
    height: 1,
    backgroundColor: COLORS.gold,
  },

  itemGroup: { marginBottom: SPACING.itemGap },
  itemGroupTight: { marginBottom: 4 },
  itemRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-end",
  },
  itemTitle: {
    fontSize: TYPE.itemTitle,
    fontFamily: FONTS.sansBold,
    color: COLORS.navy,
  },
  itemTitleAlt: { color: COLORS.goldDeep, fontFamily: FONTS.sansBold },
  itemTitleMuted: { fontFamily: FONTS.sans, color: COLORS.slate },
  itemSubtitle: {
    fontSize: TYPE.body,
    fontFamily: FONTS.sansItalic,
    color: COLORS.slate,
    marginTop: 1,
  },
  itemDate: { fontSize: TYPE.meta, color: COLORS.slate },

  body: { fontSize: TYPE.body, color: COLORS.navy, marginTop: 2 },
  meta: { fontSize: TYPE.meta, color: COLORS.slate, marginTop: 2 },
  chipsLine: { fontSize: TYPE.body, marginTop: 3, color: COLORS.slate },
  labelStrong: { fontFamily: FONTS.sansBold, color: COLORS.navy },
  italic: { fontFamily: FONTS.sansItalic },

  bullets: { marginTop: 4 },
  bulletRow: { flexDirection: "row", marginBottom: 2 },
  bulletMark: { width: 10, fontSize: TYPE.body, color: COLORS.goldDeep },
  bulletText: { flex: 1, fontSize: TYPE.body, color: COLORS.navy },

  link: { color: COLORS.rust, textDecoration: "underline" },
  linkSmall: {
    color: COLORS.rust,
    textDecoration: "underline",
    fontSize: TYPE.meta,
  },
};
